<template>
  <TemplatePageGrid
    v-if="page.grid"
    :items="page.grid"
    :page-data="page.pageData"
  >
    <template v-slot:buttons>
      <SettingFinanceModal
        :text="page.modalText"
        :fields="page.fields"
        :save-function="onSaveItem"
        :key="'create' + key"
        :disabled="!page.query"
      />
    </template>
    <BaseTableView :head="page.fields">
      <tr v-for="(item, i) in page.grid" :key="i">
        <template v-for="(field, f) in page.fields">
          <td v-if="field.field" :key="f">{{ item[field.field] }}</td>
        </template>
        <td>
          <div class="buttons">
            <SettingFinanceModal
              :data="item"
              :text="page.modalText"
              :fields="page.fields"
              :save-function="onSaveItem"
              :key="'edit' + key"
            />
            <DeleteModal
              :text="localStorage.translations.pages.common.buttons['udalit'] + ' ' + item.description + '?'"
              :delete-id="item.id"
              :method-delete="onDeleteItem"
              :key="'delete' + key"
            />
          </div>
        </td>
      </tr>
    </BaseTableView>
  </TemplatePageGrid>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import DeleteModal from "components/DeleteModal";
import SettingFinanceModal from "components/setting/finance/SettingFinanceModal";

export default {
  name: "settingFinancePage",
  components: {SettingFinanceModal, DeleteModal},
  data: () => ({
    key: 0,
  }),
  computed: {
    ...mapGetters('commonVatCode', {
      pageData1: 'getPageData',
      grid1: 'getCommonVatCodeGrid',
      item1: 'getCommonVatCode',
    }),
    ...mapGetters('commonPaymentTerms', {
      pageData2: 'getPageData',
      grid2: 'getCommonPaymentTermGrid',
      item2: 'getCommonPaymentTerm',
    }),

    t() {
      return this.localStorage.translations.pages.setting['settings-finance']
    },
    notifications() {
      return this.localStorage.translations.pages.common.notifications
    },
    page() {
      let result = {}
      switch (this.$route.name) {
        case 'SettingFinance':
          result = {
            query: {
              grid: 'onCommonVatCodeGrid',
              deleteItem: 'onCommonVatCodeDelete',
              editItem: 'onCommonVatCodeUpdate',
              createItem: 'onCommonVatCodeCreate',
            },
            pageData: this.pageData1,
            grid: this.grid1,
            item: this.item1,
            fields: [
              {text: this.t['vat-code'], field: 'code'},
              {text: this.t['vat-percent'], field: 'percent'},
              {text: this.t['description'], field: 'description'},
              {text: '', active: true},
            ],
            modalText: {
              title: {
                edit: this.t['edit-vat-code'],
                create: this.t['create-vat-code'],
              },
              button: {
                open: this.t['create-vat-code'],
              }
            }
          }
          break
        case 'SettingFinanceTermsOfPayment':
          result = {
            query: {
              grid: 'onCommonPaymentTermGrid',
              deleteItem: 'onCommonPaymentTermDelete',
              editItem: 'onCommonPaymentTermUpdate',
              createItem: 'onCommonPaymentTermCreate',
            },
            pageData: this.pageData2,
            grid: this.grid2,
            item: this.item2,
            fields: [
              {text: this.t['code'], field: 'days'},
              {
                text: this.localStorage.translations.pages.finance['invoice-table']['day_term'],
                field: 'description'
              },
              {text: '', active: true},
            ],
            modalText: {
              title: {
                edit: this.t['edit-vat-percent'],
                create: this.t['create-vat-percent'],
              },
              button: {
                open: this.t['create-vat-percent'],
              }
            }
          }
          break
        default:
          result = {}
      }
      return result
    }
  },
  watch: {
    '$route.query'(newData, oldData) {
      this.getPageData()
    },
    '$route.name'() {
      this.getPageData()
    },
  },
  created() {
    this.getPageData()
  },
  methods: {
    ...mapActions('commonVatCode',
      ['onCommonVatCodeGrid', 'onCommonVatCodeDelete', 'onCommonVatCodeUpdate', 'onCommonVatCodeCreate']),
    ...mapActions('commonPaymentTerms',
      ['onCommonPaymentTermGrid', 'onCommonPaymentTermDelete', 'onCommonPaymentTermUpdate', 'onCommonPaymentTermCreate']),

    async getPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.page.query)
        await this[this.page.query.grid](data).then(() => {
          this.key++
        })
    },

    async onDeleteItem(id) {
      await this[this.page.query.deleteItem](id).then(() => {
        this.getPageData()
      })
    },

    async onSaveItem(item) {
      await this[this.page.query[item.id ? 'editItem' : 'createItem']](item)
        .then(() => {
          this.onNotification()
          this.key++
          this.getPageData()
        })
        .catch((err) => {
          console.log(err)
          this.onNotification(err.response.data.message || JSON.stringify(err.response.data) )
        })
    },

    onNotification(err) {
      let msg = err ? this.notifications['oshibka'] + ' ' + err : this.notifications['izmeneniya-uspeshno-sohraneny']
      this.$store.dispatch(
        'popup/onMessage',
        {message: msg, IsError: !!err},
        {root: true},
      )
    },

  }
}
</script>